import { apiRequest } from '@/lib/api-client';

export interface HealthStatus {
  status: 'ok' | 'degraded';
  uptimeSeconds: number;
  timestamp: string;
  checks: { database: 'up' | 'down' };
}

export const fetchHealth = (): Promise<HealthStatus> => apiRequest<HealthStatus>('/health');
